import snapShotService from '../../../core/services/Fundamental/SnapShotService';
import { getSyncDefaultSearch } from '../../helpers/Common';
import reducerRegistry from '../../helpers/ReducerRegistry';
import financialStatementService from '../../../core/services/Fundamental/FinancialStatementService';
import priceDatService from '../../../core/services/Prices/PriceData/PriceDataService';
import { DEFAULT_CODE } from './Const';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../app/commonReducer';
import {
  formatBalanceSheetData,
  formatCashFlowStatementData,
  formatIncomeStatementData,
} from './helper';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';
import { handleExport } from './../../helpers/HandleExport';

export const REDUCER_NAME = 'FUNDAMENTAL:FINANCIAL_STATEMENT';
const FETCH_BALANCE_SHEET_SUCCESS = `${REDUCER_NAME}_FETCH_BALANCE_SHEET_SUCCESS`;
const SET_CODE = `${REDUCER_NAME}_SET_CODE`;
const SET_BALANCE_SHEET_LOADING = `${REDUCER_NAME}_SET_BALANCE_SHEET_LOADING`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const FETCH_LATEST_PRICE_SUCCESS = `${REDUCER_NAME}FETCH_LATEST_PRICE_SUCCESS`;

const FETCH_INCOME_STATEMENT_SUCCESS = `${REDUCER_NAME}_FETCH_INCOME_STATEMENT_SUCCESS`;
const SET_INCOME_STATEMENT_LOADING = `${REDUCER_NAME}_SET_INCOME_STATEMENT_LOADING`;

const FETCH_CASH_FLOW_STATEMENT_SUCCESS = `${REDUCER_NAME}_FETCH_CASH_FLOW_STATEMENT_SUCCESS`;
const SET_CASH_FLOW_STATEMENT_LOADING = `${REDUCER_NAME}_SET_CASH_FLOW_STATEMENT_LOADING`;

const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

const FETCH_COMPANY_SCORE_SUCCESS = `${REDUCER_NAME}_FETCH_COMPANY_SCORE_SUCCESS`;
const UPDATE_SKIP = `${REDUCER_NAME}_UPDATE_SKIP`;

const getComTypeCode = (getState, organCode) => {
  const organization = getState()[COMMON_REDUCER_NAME]
    .listOrganizationByOrganCode[organCode];

  return organization ? organization.comTypeCode : '';
};

export const downloadBalanceSheet = (params, fileName) => dispatch => {
  financialStatementService.downloadBalanceSheet(params).then(response => {
    handleExport(response, fileName);
  });
};

export const downloadCashFlow = (params, fileName) => dispatch => {
  financialStatementService.downloadCashFlow(params).then(response => {
    handleExport(response, fileName);
  });
};

export const downloadIncomeStatement = (params, fileName) => dispatch => {
  financialStatementService.downloadIncomeStatement(params).then(response => {
    handleExport(response, fileName);
  });
};

export const fetchCompanyScore = (params, id) => dispatch => {
  snapShotService.getCompanyScore(params).then(response => {
    dispatch({
      type: FETCH_COMPANY_SCORE_SUCCESS,
      payload: {
        id,
        score: response.items && response.items[0] ? response.items[0] : {},
      },
    });
  });
};

export const fetchBalanceSheet = (params, id) => (dispatch, getState) => {
  const comTypeCode = getComTypeCode(getState, params.OrganCode);
  dispatch(setBalanceSheetLoading(true, id));
  financialStatementService.getBalanceSheet(params).then(response => {
    dispatch(fetchBalanceSheetSuccess(response, id, comTypeCode));
  });
};

export const fetchBalanceSheetSuccess = (payload, id, comTypeCode) => ({
  type: FETCH_BALANCE_SHEET_SUCCESS,
  payload: {
    id,
    data: payload,
    comTypeCode,
  },
});

export const fetchLatestPrice = (params, id) => dispatch => {
  priceDatService.getLatestPrice(params).then(response => {
    const price = Array.isArray(response.items)
      ? response.items[0]
      : { priceInfo: {} };

    dispatch(fetchLatestPriceSuccess(price, id));
  });
};

export const fetchLatestPriceSuccess = (price, id) => ({
  type: FETCH_LATEST_PRICE_SUCCESS,
  payload: {
    id,
    price: price.priceInfo,
  },
});

export const fetchIncomeStatement = (params, id) => (dispatch, getState) => {
  dispatch(setIncomeStatementLoading(true, id));
  const comTypeCode = getComTypeCode(getState, params.OrganCode);
  financialStatementService.getIncomeStatement(params).then(response => {
    dispatch({
      type: FETCH_INCOME_STATEMENT_SUCCESS,
      payload: {
        id,
        comTypeCode,
        data: response,
      },
    });
  });
};

export const setIncomeStatementLoading = (bool, id) => ({
  type: SET_INCOME_STATEMENT_LOADING,
  payload: {
    isLoading: bool,
    id,
  },
});

export const setCode = (payload, id) => ({
  type: SET_CODE,
  payload: {
    id,
    data: payload,
  },
});

export const setBalanceSheetLoading = (bool, id) => ({
  type: SET_BALANCE_SHEET_LOADING,
  payload: {
    id,
    isLoading: bool,
  },
});

export const fetchCashFlowStatement = (params, id) => (dispatch, getState) => {
  dispatch(setCashFlowStatementLoading(true, id));
  const comTypeCode = getComTypeCode(getState, params.OrganCode);
  financialStatementService.getCashFlowStatement(params).then(response => {
    dispatch({
      type: FETCH_CASH_FLOW_STATEMENT_SUCCESS,
      payload: {
        id,
        comTypeCode,
        data: response,
      },
    });
  });
};

export const setCashFlowStatementLoading = (bool, id) => ({
  type: SET_CASH_FLOW_STATEMENT_LOADING,
  payload: {
    isLoading: bool,
    id,
  },
});

export const updateSkip = (componentId, skip) => ({
  type: UPDATE_SKIP,
  payload: {
    id: componentId,
    skip,
  },
});

const initialData = {
  isLoading: true,
  skip: 0,
  isNoData: false,
  data: {
    quarterly: {
      ids: [],
      dataByIds: {},
      fields: [],
    },
    yearly: {
      ids: [],
      dataByIds: {},
      fields: [],
    },
  },
};

const initComponentData = {
  score: {},
  balanceSheet: initialData,
  cashFlowStatement: initialData,
  incomeStatement: initialData,
  latestPrice: {},
  skip: 0,
};

const initialState = {};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
        [action.payload.id]: {
          currentSearch: action.payload.dragCode ||
            currentState.get(
              ConstCommon.listComponent.FinancialStatement,
              'currentSearch',
              action.payload.id,
            ) ||
            getSyncDefaultSearch(
              ConstCommon.listComponent.FinancialStatement,
              true,
            ) || {
              code: DEFAULT_CODE,
              displayCode: DEFAULT_CODE,
            },
          ...initComponentData,
          ...(state[action.payload.id] || {}),
        },
      };

    case UNMOUNT_COMPONENT:
      const { [action.payload.id]: _, ...rest } = state;

      return rest;

    case FETCH_BALANCE_SHEET_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          balanceSheet: {
            ...state[action.payload.id].balanceSheet,
            isLoading: false,
            data: formatBalanceSheetData(
              action.payload.data.items ? action.payload.data.items[0] : [],
              action.payload.comTypeCode,
            ),
            rawData: action.payload.data.items
              ? action.payload.data.items[0]
              : {},
          },
        },
      };

    case SET_BALANCE_SHEET_LOADING:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          balanceSheet: {
            ...state[action.payload.id].balanceSheet,
            isLoading: action.payload.isLoading,
          },
        },
      };

    case FETCH_INCOME_STATEMENT_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          incomeStatement: {
            ...state[action.payload.id].incomeStatement,
            isLoading: false,
            data: formatIncomeStatementData(
              action.payload.data.items ? action.payload.data.items[0] : {},
              action.payload.comTypeCode,
            ),
            rawData: action.payload.data.items
              ? action.payload.data.items[0]
              : {},
          },
        },
      };

    case FETCH_CASH_FLOW_STATEMENT_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          cashFlowStatement: {
            ...state[action.payload.id].cashFlowStatement,
            isLoading: false,
            data: formatCashFlowStatementData(
              action.payload.data.items ? action.payload.data.items[0] : {},
              action.payload.comTypeCode,
            ),
            rawData: action.payload.data.items
              ? action.payload.data.items[0]
              : {},
          },
        },
      };

    case SET_INCOME_STATEMENT_LOADING:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          incomeStatement: {
            ...state[action.payload.id].incomeStatement,
            isLoading: action.payload.isLoading,
          },
        },
      };

    case SET_CASH_FLOW_STATEMENT_LOADING:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          cashFlowStatement: {
            ...state[action.payload.id].cashFlowStatement,
            isLoading: action.payload.isLoading,
          },
        },
      };

    case SET_CODE:
      const { code, displayCode, comTypeCode } = action.payload.data;

      currentState.add(
        ConstCommon.listComponent.FinancialStatement,
        'currentSearch',
        { code, displayCode, comTypeCode },
        action.payload.id,
      );
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          currentSearch: action.payload.data,
        },
      };

    case CHANGE_SIZE_COMPONENT:
      const { width, height, id } = action.payload;
      return {
        ...state,
        [id]: {
          ...(state[id] || {}),
          size: {
            width,
            height,
          },
        },
      };

    case FETCH_LATEST_PRICE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          latestPrice: action.payload.price,
        },
      };

    case FETCH_COMPANY_SCORE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          score: action.payload.score,
        },
      };

    case UPDATE_SKIP:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          skip: action.payload.skip,
        },
      };

    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
